module.exports = __webpack_public_path__ + "static/img/machine_l_heading.d3e225e3.png";